import BlueFire from "../../../core/assets/oot/gshd/bottle-blue-fire_32x32.png";
import BaseItem, { BaseItemProps } from "../../../core/items/BaseItem";
import { ItemDto } from "../../../core/items/ItemDataTypes";
import StaticItem from "../../../core/items/StaticItem";
import { SimpleItemProps } from "./SimpleItemProps";



const BlueFireBottleItem = (props: BaseItemProps) => {
    return <BaseItem {...props} image={BlueFire} title="Blue Fire" />
}

export default BlueFireBottleItem;

export const defaultBlueFireBottle: ItemDto = {
    defaultIcon: BlueFire,
    title: "Blue Fire",
    component: BlueFireBottleItem,
}



export const SimpleBlueFireBottleItem = (props: SimpleItemProps) => {


    return <StaticItem
        image={BlueFire}
        onClick={props.onClick}
        name={"Blue Fire"}
    />


}